import { Locale, K } from "../constants";

const locale: Locale = {
  [K.AGENT_STATUS_NORMAL]: "正常",
  [K.AGENT_STATUS_ABNORMAL]: "异常",
  [K.AGENT_STATUS_NOT_INSTALLED]: "未安装",
  [K.AGENT_STATUS_UNINSTALLED]: "已卸载",
  [K.AGENT_STATUS_UNDER_MAINTENANCE]: "维护中",
  [K.ALERT_MSG_SENDED]: "告警已发送",
  [K.ALERT_CONVERGED]: "告警被收敛",
  [K.ALERT_RECOVERED]: "告警已恢复",
  [K.ALERT_MANUAL_RECOVERED]: "人工恢复",
  [K.ALERT_SHIELDED]: "告警被屏蔽",
  [K.PRESENTATIONAL_BRICKS]: "Presentational Bricks",
  [K.PAGINATION_TOTAL_TEXT]: "共",
  [K.PAGINATION_TOTAL_UNIT]: "条",
  [K.UNKNOWN_ERROR]: "未知错误",
  [K.NO_DATA]: "暂无数据",
  [K.COLLECTION_INSTANCE_SYNCHRONIZE]: "同步实例",
  [K.COLLECTION_INSTANCE_EXECUTE]: "立即采集",
  [K.DELETE]: "删除",
  [K.CROP_TITLE]: "修改头像",
  [K.COPY]: "复制",
  [K.COPIED]: "复制成功",
  [K.COPY_FAILED]: "复制失败",
  [K.NO_TEXT_TO_COPY]: "没有可复制的文本",
  [K.CHOSEN_OPTIONS]: "已选择 {{count}} 项",
  [K.SELECTED_OPTIONS]: "已选 {{number}} 项",
  [K.CLEAR]: "清空",
  [K.ITEMS]: "项",
  [K.SELECT_ALL]: "全选",
  [K.SELECTED]: "已选",
  [K.FULL_TEXT_SEARCH]: "全文搜索",
  [K.IP_SEARCH]: "IP搜索 ",
  [K.SORT]: "排序",
  [K.PREVIEW]: "预览",
  [K.NO_ALERT]: "不再提示",
  [K.EDIT]: "编辑",
  [K.COPY_CODE]: "复制代码",
  [K.CODE_COPIED]: "代码已复制到剪贴板",
  [K.CODE_COPY_FAILED]: "复制失败，请手动复制",
  [K.CLUSTER_TYPE_NONE]: "无",
  [K.CLUSTER_TYPE_DEVELOPMENT]: "开发",
  [K.CLUSTER_TYPE_TEST]: "测试",
  [K.CLUSTER_TYPE_PRODUCTION]: "生产",
  [K.CLUSTER_TYPE_PRE_RELEASE]: "预发布",
  [K.PLEASE_ENTER_THE_SEARCH_CONTENT]: "请输入搜索内容",
  [K.COUNT_ITEMS]: "{{count}} 项",
  [K.EXPAND]: "展开",
  [K.COLLAPSE]: "收起",
  [K.TIP]: "提示",
  [K.MAX_SELECTED_EXCEEDED]: "所选数量超过最大限制（{{max}}），请重新选择",
  [K.GOT_IT]: "知道了",
  [K.MAX_SELECT_COUNT]: "最多选择 {{max}} 个",
  [K.ACTIONS]: "操作",
  [K.CONFIRM]: "确定",
  [K.CANCEL]: "取消",
  [K.NO_SEARCH_RESULT]: "搜索无结果",
  [K.ADD]: "添加",
  [K.PLEASE_ADD_SERVICE_NODE]: "请添加服务节点",
  [K.NOTICE]: "通知",
  [K.WARNING]: "警告",
  [K.URGENT]: "紧急",
  [K.DATASOURCE_EMPTY_ERROR]: "参数“dataSource”为空",
  [K.DELETE_CONFIRM_MESSAGE]: "确认要删除 <1>{{name}}</1> 吗？",
  [K.DELETE_CONFIRM_DETAIL]:
    "该删除操作将抹除所有与其相关的数据，请确认后在下方输入 <1>{{name}}</1> 来解锁确定按钮。",
  [K.DELETE_CONFIRM_INPUT_HINT]: "请输入 {{name}}",
};

export default locale;
